import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Icon, TextArea } from 'semantic-ui-react';
import { Input, InputWithSuggestions } from '../../../Elements';
import { RootConsumer } from '../../../RootComponent';
import Formsy from 'formsy-react';
import styles from '../Contract.scss';
import shareStyles from '../../Sections/Actions/Share/Share.scss';

class RequestSignature extends Component {
  static propTypes = {
    to: PropTypes.string,
    cc: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string,
    emailSuggestions: PropTypes.array.isRequired,
    emailSignLink: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
    previous: PropTypes.func.isRequired,
    copyButton: PropTypes.func.isRequired,
    selectedSignatureBlock: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      showSignLink: false,
      showCc: false,
      submitted: false
    };
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.toggleSignLink = this.toggleSignLink.bind(this);
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
  }

  toggleSignLink() {
    this.setState(prevState => ({ showSignLink: !prevState.showSignLink }));
  }

  render() {
    const {
      copyButton,
      to,
      cc,
      subject,
      message,
      emailSuggestions,
      emailSignLink,
      onClose,
      onFocus,
      onEmailChange,
      onTextChange,
      previous,
      selectedSignatureBlock
    } = this.props;
    const { showCc, showSignLink, submitted } = this.state;
    return [
      <Grid.Row key='requestSignature'>
        <Grid.Column textAlign='left'>
          <div>
            {!showSignLink &&
              <div style={{ position: 'relative' }}>
                <Formsy.Form
                  onValidSubmit={emailSignLink}
                  onInvalidSubmit={this.onInvalidSubmit}
                  autoComplete='off'
                  ref='emailForm'
                >
                  <InputWithSuggestions
                    label='To'
                    name='to'
                    value={to}
                    onChange={onEmailChange}
                    submitted={submitted}
                    placeholder='Email address...'
                    className={!showCc ? shareStyles.toField : null}
                    fluid
                    required
                    validations='isEmail'
                    autoComplete='off'
                    options={emailSuggestions}
                    validationError='Valid email address required'
                  />
                  <br />
                  {showCc &&
                    <React.Fragment>
                      <InputWithSuggestions
                        label='Cc'
                        name='cc'
                        value={cc}
                        onChange={onEmailChange}
                        submitted={submitted}
                        placeholder='Email address...'
                        fluid
                        validations='isEmail'
                        autoComplete='off'
                        options={emailSuggestions}
                        validationError='Valid email address required'
                      />
                    </React.Fragment>}
                  {!showCc &&
                    <RootConsumer>
                    {({ isMobile }) => (
                      <a
                        style={{
                          position: 'absolute',
                          top: isMobile ? '2.125em' : '2.25em',
                          right: '1.125em'
                        }}
                        onClick={() => this.setState({ showCc: true })}
                      >
                        Cc
                      </a>
                    )}
                    </RootConsumer>}
                  <Input
                    label='Subject'
                    name='subject'
                    value={subject}
                    onChange={onTextChange}
                    submitted={submitted}
                    fluid
                    required
                    validationError='Subject is required'
                  />
                  <br />
                  <div className='ui form'>
                    <div style={{ marginBottom: '0.25em' }}>
                      <strong>
                        <label htmlFor='message'>Message</label>
                      </strong>
                    </div>
                    <TextArea
                      placeholder='Enter a personal message'
                      name='message'
                      id='message'
                      value={message}
                      onChange={onTextChange}
                    />
                  </div>
                </Formsy.Form>
                <p>
                  <a onClick={this.toggleSignLink}>
                    <br />
                    Get shareable link <Icon name='linkify' />
                  </a>
                </p>
              </div>}
            {showSignLink &&
              <div>
                <h4>You can copy, paste and share this link.</h4>
                <Formsy.Form>
                  <Input
                    fluid
                    name='share_url'
                    onFocus={onFocus}
                    value={`${process.env
                      .BASE_URL}/open/sign/${selectedSignatureBlock.share_token}`}
                    onChange={() => {}}
                    action={copyButton(
                      `${process.env
                        .BASE_URL}/open/sign/${selectedSignatureBlock.share_token}`
                    )}
                    style={{
                      marginTop: '1em',
                      marginBottom: '1em'
                    }}
                  />
                </Formsy.Form>
                <p>
                  <a onClick={this.toggleSignLink}>
                    Share via email <Icon name='mail outline' />
                  </a>
                </p>
              </div>}
          </div>
        </Grid.Column>
      </Grid.Row>,
      <Grid.Row columns='equal' verticalAlign='middle' key='controls'>
        <Grid.Column textAlign='left'>
          <a onClick={previous}>&lt; Back</a>
        </Grid.Column>
        <Grid.Column textAlign='right'>
          {showSignLink &&
            <Button primary content='Close' onClick={onClose} />}
          {!showSignLink &&
            <div>
              <a className={styles.modalCancel} onClick={onClose}>
                Cancel
              </a>
              <Button
                primary
                content='Send'
                onClick={() => this.refs.emailForm.submit()}
              />
            </div>}
        </Grid.Column>
      </Grid.Row>
    ];
  }
}

export default RequestSignature;



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/Share/RequestSignature.js